import { Heading } from '@chakra-ui/react';
import React from 'react';

import styles from './browse-heading.module.scss';

export const BrowseHeading = ({ children }: { children: React.ReactNode }) => (
  <Heading as="h3" className={styles.browseHeading} fontFamily="KiaSignature">
    {children}
  </Heading>
);
